/**
 * We submit prompts to the server for approval. This enum helps us keep track of a submission network request's current status.
 */ export var SubmissionStatus = /*#__PURE__*/ function(SubmissionStatus) {
    SubmissionStatus["Idle"] = "idle";
    SubmissionStatus["AwaitingResponse"] = "awaiting-response";
    SubmissionStatus["Error"] = "error";
    return SubmissionStatus;
}({});
/**
 * Prompt submissions could be rejected or outright fail for a number of reasons.
 */ export var SubmissionError = /*#__PURE__*/ function(SubmissionError) {
    SubmissionError["Unknown"] = "unknown";
    SubmissionError["ForbiddenTermsInPrompt"] = "forbidden-terms";
    SubmissionError["NotEnoughStashSpace"] = "not-enough-stash-space";
    SubmissionError["NotEnoughPoints"] = "not-enough-points";
    SubmissionError["ValidationError"] = "validation-error";
    return SubmissionError;
}({});
export var ArtStyle = /*#__PURE__*/ function(ArtStyle) {
    ArtStyle["Default"] = "default";
    ArtStyle["Fantasy"] = "fantasy";
    ArtStyle["Anime"] = "anime";
    ArtStyle["Anthro"] = "anthro";
    ArtStyle["Photographic"] = "photographic";
    ArtStyle["Vaporwave"] = "vaporwave";
    ArtStyle["Lowpoly"] = "lowpoly";
    ArtStyle["Origami"] = "origami";
    ArtStyle["LineArt"] = "line_art";
    ArtStyle["CraftClay"] = "craft_clay";
    ArtStyle["Cinematic"] = "cinematic";
    ArtStyle["ThreeDModel"] = "3d_model";
    ArtStyle["PixelArt"] = "pixel_art";
    return ArtStyle;
}({});
/**
 * From whence a user selected a deviation for use as a variation target.
 */ export var VariationSource = /*#__PURE__*/ function(VariationSource) {
    VariationSource["Dreamup"] = "dreamup";
    VariationSource["MediaSelector"] = "media-selector";
    return VariationSource;
}({});

//# sourceMappingURL=types.js.map